import { Card } from 'antd';
import { useWindowSize } from 'react-use';
import { FloorPlanDetection } from '../../../__generated__/graphql';
import { isMobileBrowser } from '../../../common/utils';

//Import css
import { useQuery } from '@apollo/client';
import { capitalize } from 'lodash';
import { CSSProperties } from 'react';
import { DEFAULT_COLORS, Level } from '../../../common/constants';
import { COLOR_CODES } from '../graphql/queries';
import '../styles/floorPlanDetectionCardMobile.less';

type DetectionData = {
  title?: string | null;
  childType?: string | null;
  confidence?: number | null;
  childId?: string | null | undefined;
  parentID?: string | null;
  parentType?: string | null;
};

export default function FloorPlanDetectionCardMobile({
  data,
  filteredDetections,
}: {
  data: FloorPlanDetection | null;
  filteredDetections?: (FloorPlanDetection | null)[];
}) {
  const { width } = useWindowSize();
  const { data: colorCodes } = useQuery(COLOR_CODES);

  const severityColors: Record<string, string> =
    colorCodes?.getColorCodesWeb?.severityColors || DEFAULT_COLORS.severity;

  const confidenceColors: Record<string, string> =
    colorCodes?.getColorCodesWeb?.confidenceColors || DEFAULT_COLORS.confidence;

  const severityRaw = data?.severity?.toLowerCase();
  const severity =
    severityRaw && Object.values(Level).includes(severityRaw)
      ? severityRaw
      : Level.Low;
  const severityColor = severityColors[severity] || '#8c8d90';

  const getDisplayTitle = () => {
    const itemTitle = data?.title || '';
    const parentID = data?.parentId;

    if (!parentID || !filteredDetections) {
      return capitalize(itemTitle);
    }

    const parentItem = filteredDetections?.find(
      (detection: DetectionData | null) => detection?.childId === parentID,
    );

    if (parentItem && parentItem.title) {
      return `${capitalize(itemTitle)} in ${capitalize(parentItem.title)}`;
    }

    return capitalize(itemTitle);
  };

  const getConfidenceLevel = (confidence: number) => {
    if (confidence >= 70) return Level.High;
    if (confidence >= 40) return Level.Medium;
    return Level.Low;
  };

  const confidenceLevel = getConfidenceLevel(data?.confidence || 0);
  const confidenceColor = confidenceColors[confidenceLevel] || '#000';

  return (
    <>
      <div className="card-div-mobile">
        <Card bordered={true} className="report-card">
          <div className="card-content-part">
            {!isMobileBrowser(width) && (
              <div className="image-section">
                <img src={data?.detectionImage || ''} alt="Image" />
              </div>
            )}

            <div className="content-section">
              <div className="title">{getDisplayTitle() || ''}</div>
              {isMobileBrowser(width) && (
                <div className="image-section">
                  <img src={data?.detectionImage ?? ''} alt="Image"></img>
                </div>
              )}
              <div className="content-tags">
                <div className="contents-tag-section-1">
                  <div className="severity">
                    <strong>Vastu Importance : </strong>
                    <span>
                      <div
                        className={severity}
                        style={
                          {
                            '--severity-color': severityColor,
                            '--severity-bg': `${severityColor}20`,
                          } as CSSProperties
                        }
                      >
                        {data?.severity}
                      </div>
                    </span>
                  </div>
                  <div className="">
                    <strong>Position : </strong>
                    <span>{data?.direction}</span>
                  </div>
                </div>
                <div className="contents-tag-section-2">
                  <div className="confidence">
                    <strong>Confidence : </strong>
                    <span>
                      <div
                        className={`confidence ${confidenceLevel}`}
                        style={
                          {
                            '--confidence-color': confidenceColor,
                            '--confidence-bg': `${confidenceColor}20`,
                          } as CSSProperties
                        }
                      >
                        {data?.confidence}%
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="contents-description-section ">
                {data?.description || 'No description available.'}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
